<template>
    <Icon name="indent-left">
        <svg version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512">
            <title>indent-left</title>
            <g>
                <path
                    d="M81.81,362.095C85.72,366.03,90.859,368,96,368c5.096,0,10.194-1.936,14.095-5.811
				c7.836-7.784,7.879-20.448,0.095-28.284l-64.332-64.763C42.081,265.364,40,260.342,40,255c0-5.342,2.081-10.364,5.905-14.189
				l64.284-64.716c7.784-7.836,7.742-20.5-0.095-28.284c-7.836-7.784-20.5-7.742-28.284,0.095l-64.237,64.668
				C6.241,223.906,0,238.974,0,255s6.241,31.094,17.526,42.379L81.81,362.095z"
                />
                <path d="M20,40h472c11.046,0,20-8.954,20-20s-8.954-20-20-20H20C8.954,0,0,8.954,0,20S8.954,40,20,40z" />
                <path
                    d="M492,472H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20
				C512,480.954,503.046,472,492,472z"
                />
                <path
                    d="M492,354H212c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h280c11.046,0,20-8.954,20-20
				C512,362.954,503.046,354,492,354z"
                />
                <path
                    d="M492,118H212c-11.046,0-20,8.954-20,20s8.954,20,20,20h280c11.046,0,20-8.954,20-20C512,126.954,503.046,118,492,118z"
                />
                <path
                    d="M492,236H212c-11.046,0-20,8.954-20,20s8.954,20,20,20h280c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
                />
            </g>
        </svg>
    </Icon>
</template>

<script>
import Icon from './icon';
export default {
    components: {
        Icon,
    },
};
</script>
